import React from "react";

import type { NoteDetail } from "@/core/types";

import { AdvancedCareActivityView } from "../(advanced-care)/AdvancedCareActivityView";
import { CareCommunicationView } from "../(care-communication)/CareCommunicationView";
import { CareCoordinationView } from "../(care-coordination)/CareCoordinationView";
import { CareManagementForm } from "../(care-management)/CareManagementForm";
import { CaseManagementView } from "../(case-management)/CaseManagementView";
import { CheckInView } from "../(check-in)/CheckInView";
import { GuidedSessionView } from "../(guided-session)/GuidedSessionView";
import { SessionNoteView } from "../(session-note)/SessionNoteView";

type NoteContentProps = {
  isEditing?: boolean;
  note: NoteDetail;
  patientName?: string;
  profileName?: string | null;
  refetchNote?: () => void;
  setIsEditing?: (v: boolean) => void;
};

export function NoteContentRouter({
  isEditing = false,
  note,
  patientName,
  profileName = null,
  refetchNote = () => {},
  setIsEditing = () => {},
}: NoteContentProps) {
  if (note?.note_type === "Care Management") {
    return (
      <CareManagementForm
        isEditing={isEditing}
        isEmbedded
        nameToSign={note.provider_name ?? profileName}
        noteState={{ ...note, signature: note.signature ?? "" }}
        patientId={note.patient_id}
        refetchNote={refetchNote}
        setIsEditing={setIsEditing}
      />
    );
  }

  if (note?.note_type === "Advanced Care Activity") {
    return <AdvancedCareActivityView isEmbedded note={note} />;
  }

  switch (note.version ?? 1) {
    case 1:
      return <SessionNoteView note={note} patientName={patientName} />;

    case 2:
      return <GuidedSessionView note={note} views={{ profileView: true }} />;

    case 3:
      return <CheckInView note={note} />;

    case 4:
      return <CareCoordinationView note={note} />;

    case 5:
      return note?.note_type !== "Discharge" ? <CareCommunicationView note={note} /> : null;

    case 6:
      return <CaseManagementView note={note} />;

    default:
      return null;
  }
}
